document.addEventListener('DOMContentLoaded', () => {
	const registerCheckBox = document.querySelector('.bbs-register__consent-checkbox');

	if (registerCheckBox) {
		const button = document.querySelector('.bbs-register__button');

		registerCheckBox.addEventListener('change', function () {
			if (this.checked) {
				button.classList.add('bbs-register__button--active');
			} else {
				button.classList.remove('bbs-register__button--active');
			}
		});
	}
});
